import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    rallies: null,
    rally: null,
    task: null,
    taskWasDeleted: false,
    saveSortingChanges: false,
    saveSortingTrigger: null,
    taskAnswerToDeleteId: null,
    inputTaskAnswerToDeleteId: null,
    rallyToDeactivateId: null,
    rallyResultsWasDeleted: false,
    taskWasPasted: false,
};
const adminRalliesSlice = createSlice({
    name: 'adminRallies',
    initialState,
    reducers: {
        setAdminRallies(state, action) {
            state.rallies = action.payload;
        },
        setAdminRally(state, action) {
            state.rally = action.payload;
        },
        setAdminTask(state, action) {
            state.task = action.payload;
        },
        setTaskAnswerToDeleteId: (state, action) => {
            state.taskAnswerToDeleteId = action.payload;
        },
        setInputTaskAnswerToDeleteId: (state, action) => {
            state.inputTaskAnswerToDeleteId = action.payload;
        },
        setRallyToDeactivateId: (state, action) => {
            state.rallyToDeactivateId = action.payload;
        },
        setTaskWasDeleted(state, action) {
            state.taskWasDeleted = action.payload;
        },
        setSaveSortingChanges(state, action) {
            state.saveSortingChanges = action.payload;
        },
        setSaveSortingTrigger(state, action) {
            state.saveSortingTrigger = action.payload;
        },
        setRallyResultsWasDeleted(state, action) {
            state.rallyResultsWasDeleted = action.payload;
        },
        setTaskWasPasted(state, action) {
            state.taskWasPasted = action.payload;
        },
    },
    selectors: {
        selectAdminRallies: (state) => state.rallies,
        selectAdminRally: (state) => state.rally,
        selectAdminTask: (state) => state.task,
        selectTaskWasDeleted: (state) => state.taskWasDeleted,
        selectSaveSortingChanges: (state) => state.saveSortingChanges,
        selectTaskAnswerToDeleteId: (state) => state.taskAnswerToDeleteId,
        selectInputTaskAnswerToDeleteId: (state) => state.inputTaskAnswerToDeleteId,
        selectRallyToDeactivateId: (state) => state.rallyToDeactivateId,
        selectSaveSortingTrigger: (state) => state.saveSortingTrigger,
        selectRallyResultsWasDeleted: (state) => state.rallyResultsWasDeleted,
        selectTaskWasPasted: (state) => state.taskWasPasted,
    },
});
export const { setAdminRallies, setAdminRally, setAdminTask, setTaskWasDeleted, setSaveSortingChanges, setTaskAnswerToDeleteId, setRallyToDeactivateId, setSaveSortingTrigger, setRallyResultsWasDeleted, setInputTaskAnswerToDeleteId, setTaskWasPasted, } = adminRalliesSlice.actions;
export const { selectAdminRallies, selectAdminRally, selectAdminTask, selectTaskWasDeleted, selectSaveSortingChanges, selectTaskAnswerToDeleteId, selectRallyToDeactivateId, selectSaveSortingTrigger, selectRallyResultsWasDeleted, selectInputTaskAnswerToDeleteId, selectTaskWasPasted, } = adminRalliesSlice.selectors;
export default adminRalliesSlice.reducer;
